module.exports = __webpack_public_path__ + "img/tj2.8c301e96.png";